import { HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { GbNotificationService } from 'libs/shared/utils/notification/src/lib/service/gb-notification.service'

export interface ErrorObject {
  [key: string]: string | string[] | undefined
}

@Injectable({
  providedIn: 'root',
})
export class GbErrorMessageService {
  constructor(private gbNotificationService: GbNotificationService) {}

  /**
   * Gets first error message from error object
   * @param errorObj: ErrorObject | string[] | undefined
   * @returns the first error value string from the provided ErrorObject object
   */

  getFirstErrorMessage(error: ErrorObject | string[] | undefined): string | undefined {
    if (Array.isArray(error)) return error[0]

    let errorMessage = ''
    const errorMessageList: string[] | string | undefined = error && error[Object.keys(error)[0]]
    if (errorMessageList) {
      if (Array.isArray(errorMessageList)) {
        errorMessage = errorMessageList[0]
      } else if (typeof errorMessageList === 'object') {
        const nestedErrorMessageList = errorMessageList[Object.keys(errorMessageList)[0]]
        errorMessage = Array.isArray(nestedErrorMessageList) ? nestedErrorMessageList[0] : nestedErrorMessageList
      } else {
        errorMessage = errorMessageList
      }
    }

    return errorMessage
  }

  /**
   * Retrieves a specific error message from the ErrorObject object or a generic error message
   * @param error: ErrorObject | undefined | string[] - the ErrorObject object from which to extract the error message
   * @returns a specific error message if available and not an HTML response; otherwise, returns a generic error message
   */

  getErrorMessage(error: ErrorObject | undefined | string[]): string {
    const firstErrorMessage = this.getFirstErrorMessage(error)

    if (firstErrorMessage && firstErrorMessage.length > 1) {
      return firstErrorMessage
    }

    return 'GENERIC.ERROR'
  }

  showError(error: HttpErrorResponse): void {
    const errorMessage = this.getErrorMessage(error.error as ErrorObject | undefined | string[])
    this.gbNotificationService.error(errorMessage)
  }
}
